export interface SimulatedOrderBookEntry {
  price: number;
  amount: number;
  total: number;
}

// Display-only levels around the provider quote. Never used for order execution.
export function generateSimulatedOrderBook(referencePrice: number, levels: number) {
  const asks: SimulatedOrderBookEntry[] = [];
  const bids: SimulatedOrderBookEntry[] = [];
  if (Number.isFinite(referencePrice) && referencePrice > 0) {
    let askTotal = 0;
    let bidTotal = 0;
    for (let index = 0; index < levels; index++) {
      // Keep each level on its side of the reference and in price order.
      const offset = (index + 1) * 0.0005;
      const askAmount = Math.random() * 2 + 0.1;
      const bidAmount = Math.random() * 2 + 0.1;
      askTotal += askAmount;
      bidTotal += bidAmount;
      asks.push({ price: referencePrice * (1 + offset + Math.random() * 0.0001), amount: askAmount, total: askTotal });
      bids.push({ price: referencePrice * (1 - offset - Math.random() * 0.0001), amount: bidAmount, total: bidTotal });
    }
  }
  return { asks, bids, lastUpdateId: Date.now() };
}
